export default __webpack_public_path__ + "static/img/vogue_scene_animated_0066.bad5909.jpg";